import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { Button } from "../../components/button";
import { H1 } from "../../components/h1";
import { Input } from "../../components/input";
import { register } from "../../services/auth";
import { useLocale } from "../../stores/locale";

export function ControlRegister() {
  const { locale, currentLanguage } = useLocale();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    setIsValid(email.length > 0 && password.length >= 8);
  }, [email, password]);

  if (isSubmitted) {
    return (
      <div className="mx-auto flex w-full max-w-xl flex-col gap-3">
        <H1>{locale.auth.registerSuccessTitle}</H1>
        <p>{locale.auth.registerSuccessBody}</p>
        <Link className="text-blue-700 hover:underline" to="/login">
          {locale.auth.backToLogin}
        </Link>
      </div>
    );
  }

  return (
    <form
      className="mx-auto flex w-full max-w-xl flex-col gap-3"
      onSubmit={(e) => {
        (async () => {
          e.preventDefault();
          setIsLoading(true);
          setHasError(false);
          try {
            await register({ email, password }, currentLanguage);
            setIsSubmitted(true);
          } catch {
            setHasError(true);
          } finally {
            setIsLoading(false);
          }
        })();
      }}
    >
      <H1>{locale.auth.registerTitle}</H1>
      <Input
        disabled={isLoading}
        hasError={hasError}
        placeholder={locale.login.email}
        type="text"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <Input
        disabled={isLoading}
        hasError={hasError}
        placeholder={locale.login.password}
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <div className="mt-2 flex items-center justify-end gap-2">
        {hasError && (
          <p className="text-red-500">{locale.auth.registerError}</p>
        )}
        <Button disabled={!isValid || isLoading} type="submit">
          {locale.auth.registerSubmit}
        </Button>
      </div>
      <Link className="text-sm text-blue-700 hover:underline" to="/login">
        {locale.auth.backToLogin}
      </Link>
    </form>
  );
}
